export class JobType {
    id!: string
    shortName!: string
    fullName!: number
    divisionId?: string
}
